import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import api from '../../services/axios';

const BanksTable = (props) => {
  const t = props.t;

  const formatTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleTimeString('es-ES', {timeZone: 'Europe/Madrid', hour12: false});
  };

  const getRowStyle = (bankEntry) => {
    const comment = bankEntry.comment;
    const amount = parseFloat(bankEntry.amount);
    if (comment && comment.toLowerCase().includes('comprobar')) {
      return { backgroundColor: '#f8d7da' };
    }
    if (amount < 0) {
      return { backgroundColor: '#ffeaa7' };
    }
    return {};
  };

  const getAmountStyle = (amount) => {
    const numAmount = parseFloat(amount);
    if (numAmount < 0) {
      return { color: '#e67e22', fontWeight: 'bold' };
    }
    return {};
  };

  const getSaldoStyle = (saldo) => {
    if (saldo < 0) {
      return { color: '#e74c3c', fontWeight: 'bold' };
    }
    return { color: '#27ae60', fontWeight: 'bold' };
  };

  const getTotalStyle = (total) => {
    if (total < 0) {
      return { color: '#e67e22', fontWeight: 'bold' };
    }
    return { fontWeight: 'bold' };
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Estás seguro de eliminar este apunte?')) return;
    try {
      await api.delete(`/bank_entries_react/${id}`, { headers: { 'Authorization': 'Bearer ' + props.loginParameters.accesToken } });
      if (props.onRefresh) props.onRefresh();
    } catch (err) {
      alert('Error al eliminar');
    }
  };

  // Usar saldo del backend si existe, sino calcular localmente
  const entries = (props.bankEntries || []).map(entry => {
    if (entry.saldo !== undefined && entry.saldo !== null) {
      return entry; // Usar saldo calculado en backend
    }
    return entry;
  });
  
  // Solo calcular localmente si no viene del backend
  if (entries.length > 0 && (entries[0].saldo === undefined || entries[0].saldo === null)) {
    const entriesReversed = [...entries].reverse();
    let saldoAcumulado = props.saldoInicial || 0;
    entriesReversed.forEach(entry => {
      saldoAcumulado += parseFloat(entry.amount || 0);
      entry.saldo = saldoAcumulado;
    });
    entriesReversed.reverse();
  }
  
  const total = (props.bankEntries || []).reduce((sum, entry) => sum + parseFloat(entry.amount || 0), 0);

  return (
    <div>
      <Table striped responsive>
        <thead className='bg-primary text-white'>
          <tr>
            <th>{t('banks.bank')}</th>
            <th>{t('banks.date')}</th>
            <th>Hora</th>
            <th>Origen</th>
            <th>{t('banks.code')}</th>
            <th>{t('banks.concept')}</th>
            <th>{t('banks.comment')}</th>
            <th>{t('banks.amount')}</th>
            <th>Saldo</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {entries.map((bankEntry) => (
            <tr key={bankEntry.id} style={getRowStyle(bankEntry)}>
              <td>{bankEntry.bank.name}</td>
              <td>{bankEntry.date}</td>
              <td>{formatTime(bankEntry.created_at)}</td>
              <td>{bankEntry.cash_origin ? bankEntry.cash_origin.name : ''}</td>
              <td>
                {bankEntry.agent
                  ? `${bankEntry.agent.income_code} - ${bankEntry.agent.user?.name || ''} ${bankEntry.agent.user?.surname || ''}`.trim()
                  : (bankEntry.concept && bankEntry.concept.name === 'Teleconnect' ? 'Teleconnect' : '')}
              </td>
              <td>{bankEntry.concept ? bankEntry.concept.name : ''}</td>
              <td>{bankEntry.comment}</td>
              <td style={getAmountStyle(bankEntry.amount)}>
                {parseFloat(bankEntry.amount).toFixed(2)}
              </td>
              <td style={getSaldoStyle(bankEntry.saldo)}>
                {bankEntry.saldo?.toFixed(2)}
              </td>
              <td>
                <Link to={"/bank_entries/edit/" + bankEntry.id}><AiFillEdit /></Link>
                {' '}
                <AiFillDelete 
                  style={{cursor: 'pointer', color: '#e74c3c'}} 
                  onClick={() => handleDelete(bankEntry.id)}
                />
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className='bg-light'>
            <td colSpan="7" className="text-end"><strong>Total:</strong></td>
            <td style={getTotalStyle(total)}>{total.toFixed(2)} €</td>
            <td></td>
            <td></td>
          </tr>
        </tfoot>
      </Table>
    </div>
  );
};

export default BanksTable;
